<?xml version="1.0" encoding="utf-8"?>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
	xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="-8 0 74 64"
>
	<g>
		<path
			stroke="white"
			stroke-width="4"
			d="M32,53c17.645,0,32-9.42,32-21S49.645,11,32,11S0,20.42,0,32S14.355,53,32,53z M32,13c16.542,0,30,8.523,30,19
			S48.542,51,32,51S2,42.477,2,32S15.458,13,32,13z" />
	</g>
</svg>